import { css, keyframes, styled } from 'goober';
import { getRandomInt } from 'mc-ui-utils';
import React, { forwardRef, memo, useCallback, useMemo, useRef } from 'react';
const getValuePercent = (total, percent) => {
    return Math.floor(total * (percent / 100));
};
const getPos = (totalValue, fromPercent, toPercent) => {
    const min = getValuePercent(totalValue, fromPercent);
    const max = getValuePercent(totalValue, toPercent);
    return getRandomInt(min, max);
};
const getAnimKeyframes = (pos, initialPosition, isActiveFloater = false, animDelay = 0) => {
    const animKeyframes = isActiveFloater
        ? keyframes `
      0% {
        transform: translate(${pos[0].x}px, ${pos[0].y}px) scale(.95);
      }
      20% {
        transform: translate(${pos[1].x}px, ${pos[1].y}px) scale(1.5);
      }
      30% {
        transform: translate(${pos[1].x}px, ${pos[1].y}px) scale(2.5);
        border-color: transparent;
      }

      44% {
        transform: translate(${pos[1].x}px, ${pos[1].y}px) scale(1.5);
      }
      
      68% {
        transform: translate(${pos[2].x}px, ${pos[2].y}px) scale(.75);
      }

      100% {
        transform: translate(${pos[3].x}px, ${pos[3].y}px) scale(0.5);
        opacity: 0
      }
    `
        : keyframes `
      0% {
        transform: translate(${pos[0].x}px, ${pos[0].y}px) scale(0.7);
      }
      30% {
        transform: translate(${pos[1].x}px, ${pos[1].y}px) scale(0.8);
      }
      
      90% {
        opacity: 1;
      }
      100% {
        transform: translate(${pos[3].x}px, ${pos[3].y}px) scale(0.8);
        opacity: 0;
      }
  `;
    return css `
    animation-name: ${animKeyframes};
    animation-duration: 3s;
    animation-timing-function: cubic-bezier(0.45, 0.25, 0.6, 0.95);
    animation-delay: ${animDelay}ms;

    ${isActiveFloater
        ? `
      filter: grayscale(0);
      &::after {

        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: 100px;
        background-color: white;
        z-index: -1;
      }
    `
        : `
        transform: translate(${pos[0].x}px, ${pos[0].y}px) scale(.25);
        opacity: 0.8;

      `}
  `;
};
const Holder = styled('div', forwardRef) `
  position: absolute;
  transform-origin: center;
  z-index: 5;
  right: calc(100% - 34px);
  bottom: 100%;
  box-sizing: border-box;
`;
const Sticker = styled('div')(({ src }) => `
  width: 34px;
  height: 34px;
  background-size: 100%;
  background-image: url('${src}');
`);
function Floater(props) {
    const elem = useRef(null);
    const { sticker, id, isActiveFloater = false, parentDimention, initialPosition, onShowEnd, animDelay, } = props;
    const onShowEndCallback = useCallback(() => {
        onShowEnd(id);
    }, [id, onShowEnd]);
    const animation = useMemo(() => {
        const parentHeight = +parentDimention.height - 52 / 2;
        const parentWidth = +parentDimention.width - 50;
        const pos = isActiveFloater
            ? [
                {
                    x: (initialPosition === null || initialPosition === void 0 ? void 0 : initialPosition.x) || 100,
                    y: getPos(parentHeight, 100, 100),
                },
                {
                    x: (initialPosition === null || initialPosition === void 0 ? void 0 : initialPosition.x) || 100,
                    y: getPos(parentHeight, 80, 80),
                },
                {
                    x: getPos(parentWidth, 70, 90),
                    y: getPos(parentHeight, 40, 60),
                },
                {
                    x: getPos(parentWidth, 80, 100),
                    y: getPos(parentHeight, 5, 25),
                },
            ]
            : [
                { x: (initialPosition === null || initialPosition === void 0 ? void 0 : initialPosition.x) || 100, y: getPos(parentHeight, 100, 100) },
                {
                    x: getPos(parentWidth, 80, 100),
                    y: getPos(parentHeight, 70, 80),
                },
                {
                    x: getPos(parentWidth, 80, 100),
                    y: getPos(parentHeight, 50, 60),
                },
                {
                    x: getPos(parentWidth, 80, 100),
                    y: getPos(parentHeight, 5, 25),
                },
            ];
        return getAnimKeyframes(pos, initialPosition, isActiveFloater, animDelay);
    }, [isActiveFloater, initialPosition, parentDimention, animDelay]);
    return (React.createElement(Holder, { ref: elem, onAnimationEnd: onShowEndCallback, id: id, className: animation },
        React.createElement(Sticker, { src: sticker })));
}
export default memo(Floater);
//# sourceMappingURL=Floater.js.map